import { render, staticRenderFns } from "./OrderSigning.vue?vue&type=template&id=3862c248&"
import script from "./OrderSigning.vue?vue&type=script&lang=js&"
export * from "./OrderSigning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports